/* RESPONSIBLE TEAM: team-inbox-management */

import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
import { SLA_BREACHED_TARGET, SLA_EVENT_TARGET } from 'embercom/lib/operator/custom-bots/constants';
import type IntlService from 'embercom/services/intl';

const TARGET_LABEL_KEYS: Record<string, string> = {
  first_reply_time: 'operator.custom-bot.trigger.before-sla-breach.target-type.first-reply-time',
  next_reply_time: 'operator.custom-bot.trigger.before-sla-breach.target-type.next-reply-time',
  resolution_time: 'operator.custom-bot.trigger.before-sla-breach.target-type.time-to-resolve',
  time_to_close: 'operator.custom-bot.trigger.before-sla-breach.target-type.time-to-close',
};

const LEAD_TIME_LABEL_KEYS: Record<number, string> = {
  300: 'operator.custom-bot.trigger.before-sla-breach.delay.5-minutes',
  600: 'operator.custom-bot.trigger.before-sla-breach.delay.10-minutes',
  900: 'operator.custom-bot.trigger.before-sla-breach.delay.15-minutes',
  1800: 'operator.custom-bot.trigger.before-sla-breach.delay.30-minutes',
  3600: 'operator.custom-bot.trigger.before-sla-breach.delay.1-hour',
};

// Renders the SLA target-type subtitle for SLA-triggered workflow rows:
//   - "When SLA breaches" (sla-breached): "{targetType}"
//   - "Before SLA breach" (sla-event):    "{targetType} · {leadTime}", falling back to
//     just "{targetType}" when the lead time isn't one of the supported presets.
export default class FormatSlaBreachedSummary extends Helper {
  @service declare intl: IntlService;

  compute(params: any) {
    let [contentData, target] = params;
    if (target !== SLA_BREACHED_TARGET && target !== SLA_EVENT_TARGET) {
      return null;
    }

    let labelKey = TARGET_LABEL_KEYS[contentData?.sla_target_type];
    if (!labelKey) {
      return null;
    }
    let targetType = this.intl.t(labelKey);

    let leadTimeKey =
      target === SLA_EVENT_TARGET
        ? LEAD_TIME_LABEL_KEYS[contentData?.sla_breach_lead_time_in_seconds]
        : undefined;
    if (leadTimeKey) {
      return this.intl.t('operator.custom-bot.trigger.before-sla-breach.summary', {
        targetType,
        duration: this.intl.t(leadTimeKey),
      });
    }

    return this.intl.t('operator.custom-bot.trigger.sla-breached.summary', { targetType });
  }
}
